//
// Get media settings (source : laravel config/media-settings.php
const configMediaSettings = window.config.mediaSettings

export default Object.freeze(configMediaSettings)
